import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  syncPosSale(id) {
    return axios.post(`${API_URL}/shopify/pos/sales/${id}/sync`, {}, { headers: authHeader() });
  },
  getPosSale(id) {
    return axios.get(`${API_URL}/shopify/pos/sales/${id}`, { headers: authHeader() });
  },
  createPosSale(payload) {
    return axios.post(`${API_URL}/shopify/pos/sales`, payload, { headers: authHeader() });
  },
  getPosProducts(params = {}) {
    return axios.get(`${API_URL}/shopify/inventory/pos`, {
      headers: authHeader(),
      params,
    });
  },
  getInventory(params = {}) {
    return axios.get(`${API_URL}/shopify/inventory`, {
      headers: authHeader(),
      params,
    });
  },
  updateInventory(productId, payload = {}) {
    return axios.patch(`${API_URL}/shopify/inventory/${productId}`, payload, {
      headers: authHeader(),
    });
  },
  updateOrderStatus(source, id, status) {
    return axios.patch(
      `${API_URL}/shopify/orders/${source}/${id}/status`,
      { status },
      { headers: authHeader() }
    );
  },
  batchUpdateOrderStatus(orders, status) {
    return axios.post(
      `${API_URL}/shopify/orders/batch-status`,
      { orders, status },
      { headers: authHeader() }
    );
  },
  updateShippingAddress(orderId, payload) {
    return axios.patch(
      `${API_URL}/shopify/orders/${orderId}/shipping-address`,
      payload,
      { headers: authHeader() }
    );
  },
  updateCustomer(orderId, payload) {
    return axios.patch(
      `${API_URL}/shopify/orders/${orderId}/customer`,
      payload,
      { headers: authHeader() }
    );
  },
  getOrders(params = {}) {
    return axios.get(`${API_URL}/shopify/orders`, {
      headers: authHeader(),
      params,
    });
  },
  getOrder(source, id) {
    return axios.get(`${API_URL}/shopify/orders/${source}/${id}`, {
      headers: authHeader(),
    });
  },
  initPicking(shopifyOrderId) {
    return axios.post(`${API_URL}/shopify/orders/picking/init`, { shopify_order_id: shopifyOrderId }, { headers: authHeader() });
  },
  scanPicking(shopifyOrderId, sku) {
    return axios.post(`${API_URL}/shopify/orders/picking/scan`, { shopify_order_id: shopifyOrderId, sku }, { headers: authHeader() });
  },
  togglePickingItem(pickingId) {
    return axios.patch(`${API_URL}/shopify/orders/picking/${pickingId}/toggle`, {}, { headers: authHeader() });
  },
  getPicking(orderId) {
    return axios.get(`${API_URL}/shopify/orders/picking/${orderId}`, { headers: authHeader() });
  },
  calculateShipping(payload) {
    return axios.post(`${API_URL}/shopify/orders/shipping/calculate`, payload, { headers: authHeader() });
  },
  generateWaybill(payload) {
    return axios.post(`${API_URL}/shopify/orders/shipping/waybill`, payload, { headers: authHeader() });
  },
  getWaybillPdf(ids) {
    return axios.post(`${API_URL}/shopify/orders/shipping/waybill-pdf`, { ids }, { headers: authHeader() });
  },
  getPickingListPdf(ids) {
    return axios.post(
      `${API_URL}/shopify/orders/picking-list-pdf`,
      { ids },
      { headers: authHeader(), responseType: "blob" }
    );
  },
  syncProducts() {
    return axios.post(`${API_URL}/shopify/products/sync`, {}, { headers: authHeader() });
  },
  pushProductToShopify(productId) {
    return axios.post(`${API_URL}/shopify/products/${productId}/push`, {}, { headers: authHeader() });
  },
  syncOrders(pageInfo = null) {
    const payload = pageInfo ? { page_info: pageInfo } : {};
    return axios.post(`${API_URL}/shopify/orders/sync`, payload, { headers: authHeader() });
  },
  generateToken(payload = {}) {
    return axios.post(`${API_URL}/shopify/oauth/token`, payload, { headers: authHeader() });
  },
  getPaymentModes() {
    return axios.get(`${API_URL}/shopify/payment-modes`, { headers: authHeader() });
  },
};
